/* global axios */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('kanban/pipelines', { accountScoped: true });
  }

  getPipelines() {
    return axios.get(this.url);
  }

  getPipeline(id) {
    return axios.get(`${this.url}/${id}`);
  }

  createPipeline(data) {
    return axios.post(this.url, { pipeline: data });
  }

  updatePipeline(id, data) {
    return axios.patch(`${this.url}/${id}`, { pipeline: data });
  }

  deletePipeline(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  setDefaultPipeline(id) {
    return axios.post(`${this.url}/${id}/set_default`);
  }

  reorderPipelines(pipelineIds) {
    return axios.patch(`${this.url}/reorder`, { pipeline_ids: pipelineIds });
  }

  reorderStages(pipelineId, stageIds) {
    return axios.patch(`${this.url}/${pipelineId}/reorder_stages`, {
      stage_ids: stageIds,
    });
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/stages`, { stage: data });
  }

  updateStage(pipelineId, stageId, data) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, {
      stage: data,
    });
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }
}

export default new PipelinesAPI();
